var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageBreakIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 26,
    viewBox: "0 0 95 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98939 26C5.33056 26 4.76656 25.7454 4.29739 25.2362C3.82822 24.7271 3.59364 24.115 3.59364 23.4V19.5H5.98939V23.4H20.3639V19.5H22.7597V23.4C22.7597 24.115 22.5251 24.7271 22.0559 25.2362C21.5868 25.7454 21.0228 26 20.3639 26H5.98939ZM3.59364 11.7V2.6C3.59364 1.885 3.82822 1.27292 4.29739 0.76375C4.76656 0.254583 5.33056 0 5.98939 0H15.5724L22.7597 7.8V11.7H20.3639V9.1H14.3745V2.6H5.98939V11.7H3.59364ZM9.58303 16.9V14.3H16.7703V16.9H9.58303ZM19.1661 16.9V14.3H26.3533V16.9H22.7597H19.1661ZM0 16.9V14.3H7.18727V16.9H0Z",
    fill: "#9C9FAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6294 14.3V16.9H35.8167V14.3H28.6294Z",
    fill: "#9C9FAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9729 14.3V16.9H45.1601V14.3H37.9729Z",
    fill: "#9C9FAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7303 14.3V16.9H64.9176V14.3H57.7303Z",
    fill: "#9C9FAB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6946 14.3V16.9H71.2882H74.8819V14.3H67.6946Z",
    fill: "#9C9FAB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6757 14.3V16.9H54.8629V14.3H47.6757Z",
    fill: "#9C9FAB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7537 14.3V16.9H81.3473H84.9409V14.3H77.7537Z",
    fill: "#9C9FAB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8127 14.3V16.9H91.4064H95V14.3H87.8127Z",
    fill: "#9C9FAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageBreakIcon);
export default __webpack_public_path__ + "static/media/page-break-icon.905abccfec2183dec6b61a60d6f4e7a6.svg";
export { ForwardRef as ReactComponent };